import Image from 'next/image';
import { type FC, memo } from 'react';

const gladeAiImgSrc = '/images/dashboard/noodle-ai-fallback.png';

const NoodleAI: FC<{ size?: number }> = memo(({ size = 24 }) => (
  <Image src={gladeAiImgSrc} alt='' width={size} height={size} />
));

NoodleAI.displayName = 'NoodleAI';

export { gladeAiImgSrc };

export default NoodleAI;
